export default __webpack_public_path__ + "static/media/steering-wheel.a24a5ea0.svg";